export const ADMINISTRATOR="A"
export const SUPERVISOR="S"
export const INSTALLER="I"
export const CUSTOMER_SUPPORT="C"
export const VIEWER="V"